import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    overrideOrganizationId: null,
    overrideOrganizationName: null,
    overrideOrganizationLogo: null
}

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setOverrideOrganization: (state, action) => {
            const { id, name, logo } = action.payload
            state.overrideOrganizationId = id
            state.overrideOrganizationName = name
            state.overrideOrganizationLogo = logo
        },
        clearOverrideOrganization: (state) => {
            state.overrideOrganizationId = null
            state.overrideOrganizationName = null
            state.overrideOrganizationLogo = null
        },
        resetAdminState: () => initialState
    },
});

export const {
    setOverrideOrganization,
    clearOverrideOrganization,
    resetAdminState
} = adminSlice.actions;

export default adminSlice.reducer;